// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV {
  min-width: 70%;
  flex-direction: column;
  text-align: center;
  display: flex;
  color: #c2bfbf;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__image-upload-error___GpRw4 {
  color: #e12b36;
  text-align: center;
  font-size: 16px;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV hr {
  background-color: #c2bfbf;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__image-editor-title___kaBEk {
  margin: 40px 0 25px 40px;
  color: #404040;
  flex: 1 1 auto;
  font-family: 'Roboto';
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  white-space: nowrap;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__image-editor-actions___QOg7g {
  display: flex;
  justify-content: flex-end;
  margin: 20px 30px 30px 0;
  width: 40%;
  float: right;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV small {
  color: #888;
  font-size: 75%;
  display: block;
  color: gray;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__material-btn-primary___Adv51 {
  background-color: #4cabce;
  font-size: 13px;
  letter-spacing: 1.8px;
  opacity: 0.9;
  color: white;
  font-weight: 300;
  line-height: 19px;
  padding: 10px 53px;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__material-btn-primary___Adv51.client-component-library-modals-ImageEditor-___image-editor__disabled-button___AwihH {
  color: gray;
  background-color: gainsboro;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__cloud-upload-icon___u1SCw {
  color: lightgray;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__modal-bottom-button___absD7 {
  padding: 10px;
  margin-left: 10px;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV .client-component-library-modals-ImageEditor-___image-editor__modal-back-button___ehzL2 {
  color: #757575;
}
.client-component-library-modals-ImageEditor-___image-editor__image-editor-close-icon___X_tRk {
  position: absolute !important;
  right: 60px;
  top: 36px;
  border: 1px solid grey !important;
  height: 20px !important;
  border-radius: 50% !important;
  -moz-border-radius: 50% !important;
  -webkit-border-radius: 50% !important;
  width: 20px !important;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-target___jRB2j {
  background-color: #fff;
  border: 2px dashed #c2bfbf;
  transition: border-color 300ms, background-color 300ms;
  max-width: 360px;
  margin: 0 auto;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-target-active____o8rf {
  background-color: rgba(76, 171, 206, 0.15);
  border: 2px dashed #4cabce;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-target-reject___w5kcC {
  background-color: rgba(175, 11, 11, 0.07);
  border-color: #bb0909;
  cursor: no-drop !important;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-message___KmQp1 {
  padding: 20px 0px;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-message___KmQp1 p {
  color: #404040;
  margin: 5px 0;
  font-size: 0.9em;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-message___KmQp1 input[type='text']::placeholder {
  text-align: left;
}
.client-component-library-modals-ImageEditor-___image-editor__file-drop-message___KmQp1 input {
  padding: 8px;
  height: 30px;
  width: 262px;
}
.client-component-library-modals-ImageEditor-___image-editor__crop-btn___p0KV6 {
  color: #757575;
  vertical-align: center;
}
.client-component-library-modals-ImageEditor-___image-editor__crop-btn___p0KV6:hover {
  cursor: pointer;
  color: #4cabce;
}
.client-component-library-modals-ImageEditor-___image-editor__mm-modal-content___ArPPa {
  margin-bottom: 20px;
  text-align: center;
}
div.client-component-library-modals-ImageEditor-___image-editor__ReactCrop___MXyhV {
  max-height: 210px;
  height: 100%;
}
div.client-component-library-modals-ImageEditor-___image-editor__ReactCrop___MXyhV img {
  height: 100%;
  max-height: 210px;
  max-width: 100%;
  background: white;
}
.client-component-library-modals-ImageEditor-___image-editor__upload-image-wrap___bpn5M img {
  width: auto;
  height: 100%;
  max-height: 210px;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./client/component-library/modals/ImageEditor/image-editor.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sDAAsD;EACtD,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".image-editor-inner-wrap {\n  min-width: 70%;\n  flex-direction: column;\n  text-align: center;\n  display: flex;\n  color: #c2bfbf;\n}\n.image-editor-inner-wrap .image-upload-error {\n  color: #e12b36;\n  text-align: center;\n  font-size: 16px;\n}\n.image-editor-inner-wrap hr {\n  background-color: #c2bfbf;\n}\n.image-editor-inner-wrap .image-editor-title {\n  margin: 40px 0 25px 40px;\n  color: #404040;\n  flex: 1 1 auto;\n  font-family: 'Roboto';\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 1;\n  white-space: nowrap;\n}\n.image-editor-inner-wrap .image-editor-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin: 20px 30px 30px 0;\n  width: 40%;\n  float: right;\n}\n.image-editor-inner-wrap small {\n  color: #888;\n  font-size: 75%;\n  display: block;\n  color: gray;\n}\n.image-editor-inner-wrap .material-btn-primary {\n  background-color: #4cabce;\n  font-size: 13px;\n  letter-spacing: 1.8px;\n  opacity: 0.9;\n  color: white;\n  font-weight: 300;\n  line-height: 19px;\n  padding: 10px 53px;\n}\n.image-editor-inner-wrap .material-btn-primary.disabled-button {\n  color: gray;\n  background-color: gainsboro;\n}\n.image-editor-inner-wrap .cloud-upload-icon {\n  color: lightgray;\n}\n.image-editor-inner-wrap .modal-bottom-button {\n  padding: 10px;\n  margin-left: 10px;\n}\n.image-editor-inner-wrap .modal-back-button {\n  color: #757575;\n}\n.image-editor-close-icon {\n  position: absolute !important;\n  right: 60px;\n  top: 36px;\n  border: 1px solid grey !important;\n  height: 20px !important;\n  border-radius: 50% !important;\n  -moz-border-radius: 50% !important;\n  -webkit-border-radius: 50% !important;\n  width: 20px !important;\n}\n.file-drop-target {\n  background-color: #fff;\n  border: 2px dashed #c2bfbf;\n  transition: border-color 300ms, background-color 300ms;\n  max-width: 360px;\n  margin: 0 auto;\n}\n.file-drop-target-active {\n  background-color: rgba(76, 171, 206, 0.15);\n  border: 2px dashed #4cabce;\n}\n.file-drop-target-reject {\n  background-color: rgba(175, 11, 11, 0.07);\n  border-color: #bb0909;\n  cursor: no-drop !important;\n}\n.file-drop-message {\n  padding: 20px 0px;\n}\n.file-drop-message p {\n  color: #404040;\n  margin: 5px 0;\n  font-size: 0.9em;\n}\n.file-drop-message input[type='text']::placeholder {\n  text-align: left;\n}\n.file-drop-message input {\n  padding: 8px;\n  height: 30px;\n  width: 262px;\n}\n.crop-btn {\n  color: #757575;\n  vertical-align: center;\n}\n.crop-btn:hover {\n  cursor: pointer;\n  color: #4cabce;\n}\n.mm-modal-content {\n  margin-bottom: 20px;\n  text-align: center;\n}\ndiv.ReactCrop {\n  max-height: 210px;\n  height: 100%;\n}\ndiv.ReactCrop img {\n  height: 100%;\n  max-height: 210px;\n  max-width: 100%;\n  background: white;\n}\n.upload-image-wrap img {\n  width: auto;\n  height: 100%;\n  max-height: 210px;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-editor-inner-wrap": `client-component-library-modals-ImageEditor-___image-editor__image-editor-inner-wrap___FUEtV`,
	"image-upload-error": `client-component-library-modals-ImageEditor-___image-editor__image-upload-error___GpRw4`,
	"image-editor-title": `client-component-library-modals-ImageEditor-___image-editor__image-editor-title___kaBEk`,
	"image-editor-actions": `client-component-library-modals-ImageEditor-___image-editor__image-editor-actions___QOg7g`,
	"material-btn-primary": `client-component-library-modals-ImageEditor-___image-editor__material-btn-primary___Adv51`,
	"disabled-button": `client-component-library-modals-ImageEditor-___image-editor__disabled-button___AwihH`,
	"cloud-upload-icon": `client-component-library-modals-ImageEditor-___image-editor__cloud-upload-icon___u1SCw`,
	"modal-bottom-button": `client-component-library-modals-ImageEditor-___image-editor__modal-bottom-button___absD7`,
	"modal-back-button": `client-component-library-modals-ImageEditor-___image-editor__modal-back-button___ehzL2`,
	"image-editor-close-icon": `client-component-library-modals-ImageEditor-___image-editor__image-editor-close-icon___X_tRk`,
	"file-drop-target": `client-component-library-modals-ImageEditor-___image-editor__file-drop-target___jRB2j`,
	"file-drop-target-active": `client-component-library-modals-ImageEditor-___image-editor__file-drop-target-active____o8rf`,
	"file-drop-target-reject": `client-component-library-modals-ImageEditor-___image-editor__file-drop-target-reject___w5kcC`,
	"file-drop-message": `client-component-library-modals-ImageEditor-___image-editor__file-drop-message___KmQp1`,
	"crop-btn": `client-component-library-modals-ImageEditor-___image-editor__crop-btn___p0KV6`,
	"mm-modal-content": `client-component-library-modals-ImageEditor-___image-editor__mm-modal-content___ArPPa`,
	"ReactCrop": `client-component-library-modals-ImageEditor-___image-editor__ReactCrop___MXyhV`,
	"upload-image-wrap": `client-component-library-modals-ImageEditor-___image-editor__upload-image-wrap___bpn5M`
};
export default ___CSS_LOADER_EXPORT___;
